import { render, staticRenderFns } from "./RecordingConsentScreen.vue?vue&type=template&id=de518222&scoped=true&"
import script from "./RecordingConsentScreen.vue?vue&type=script&lang=ts&"
export * from "./RecordingConsentScreen.vue?vue&type=script&lang=ts&"
import style0 from "./RecordingConsentScreen.vue?vue&type=style&index=0&id=de518222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de518222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de518222')) {
      api.createRecord('de518222', component.options)
    } else {
      api.reload('de518222', component.options)
    }
    module.hot.accept("./RecordingConsentScreen.vue?vue&type=template&id=de518222&scoped=true&", function () {
      api.rerender('de518222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RecordingConsentScreen.vue"
export default component.exports